module.exports = __webpack_public_path__ + "img/9.31026f15.jpg";